import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";
import store from "@/store";
import PersetujuanRanapSvc from "@/services/PersetujuanRanap";

@Module({ store, dynamic: true, namespaced: true, name: "persetujuan-ranap" })
class PersetujuanRanapModule extends VuexModule {
  persetujuan: any = null;
  loading = false;

  @Mutation SET_PERSETUJUAN(val: any) {
    this.persetujuan = val;
  }

  @Mutation SET_LOADING(val: boolean) {
    this.loading = val;
  }

  @Action async getByRegister(reg: string | number) {
    this.SET_LOADING(true);

    try {
      const dt = await PersetujuanRanapSvc.getByRegister(reg);
      const { data } = dt.data;
      this.SET_PERSETUJUAN(data);
    } catch {
      this.SET_PERSETUJUAN(null);
    }

    this.SET_LOADING(false);
  }

  @Action async refresh(id: number) {
    this.SET_LOADING(true);

    try {
      const dt = await PersetujuanRanapSvc.find(id);
      const { data } = dt.data;
      this.SET_PERSETUJUAN(data);
    } catch {
      this.SET_PERSETUJUAN(null);
    }

    this.SET_LOADING(false);
  }

  @Action reset() {
    this.SET_PERSETUJUAN(null);
  }
}

export const storePersetujuanRanap = getModule(PersetujuanRanapModule);
